import {tanzanite} from '../sass/base/_exports.sass';

export const SparkleIcon = (props) => {
  const {color = tanzanite, className = '', ratio = 1} = props;
  // default dimensions
  const width = 16;
  const height = 16;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.467 0.373965C7.50677 0.264385 7.57932 0.169708 7.67478 0.1028C7.77025 0.0358927 7.88399 0 8.00057 0C8.11714 0 8.23089 0.0358927 8.32635 0.1028C8.42181 0.169708 8.49436 0.264385 8.53413 0.373965L9.07678 1.8566C9.50182 3.0192 10.1755 4.07502 11.0508 4.95032C11.9261 5.82562 12.9819 6.49931 14.1445 6.92435L15.626 7.467C15.7356 7.50677 15.8303 7.57932 15.8972 7.67478C15.9641 7.77025 16 7.88399 16 8.00057C16 8.11714 15.9641 8.23089 15.8972 8.32635C15.8303 8.42181 15.7356 8.49436 15.626 8.53413L14.1445 9.07678C12.9819 9.50182 11.9261 10.1755 11.0508 11.0508C10.1755 11.9261 9.50182 12.9819 9.07678 14.1445L8.53413 15.626C8.49436 15.7356 8.42181 15.8303 8.32635 15.8972C8.23089 15.9641 8.11714 16 8.00057 16C7.88399 16 7.77025 15.9641 7.67478 15.8972C7.57932 15.8303 7.50677 15.7356 7.467 15.626L6.92435 14.1445C6.49931 12.9819 5.82562 11.9261 4.95032 11.0508C4.07502 10.1755 3.0192 9.50182 1.8566 9.07678L0.373965 8.53413C0.264385 8.49436 0.169708 8.42181 0.1028 8.32635C0.0358927 8.23089 0 8.11714 0 8.00057C0 7.88399 0.0358927 7.77025 0.1028 7.67478C0.169708 7.57932 0.264385 7.50677 0.373965 7.467L1.8566 6.92435C3.0192 6.49931 4.07502 5.82562 4.95032 4.95032C5.82562 4.07502 6.49931 3.0192 6.92435 1.8566L7.467 0.373965Z"
        fill={color}
      />
    </svg>
  );
};
